var _path, _circle, _circle2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCouponDisabled = function SvgCouponDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 4.125C0.75 3.50368 1.25368 3 1.875 3H22.125C22.7463 3 23.25 3.50368 23.25 4.125L23.25 7.5C23.25 8.12132 22.7325 8.60664 22.1454 8.80992C20.8239 9.26743 19.875 10.5229 19.875 12C19.875 13.4771 20.8239 14.7326 22.1454 15.1901C22.7325 15.3934 23.25 15.8787 23.25 16.5L23.25 19.875C23.25 20.4963 22.7463 21 22.125 21H1.875C1.25368 21 0.749998 20.4963 0.749998 19.875L0.749998 16.5C0.749998 15.8787 1.2675 15.3934 1.85463 15.1901C3.1761 14.7326 4.125 13.4771 4.125 12C4.125 10.5229 3.1761 9.26743 1.85463 8.80992C1.2675 8.60664 0.749999 8.12132 0.749999 7.5L0.75 4.125Z",
    fill: "#C2C8CF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.49452,
    cy: 9.33203,
    r: 1.41655,
    transform: "rotate(-45 9.49452 9.33203)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5043,
    cy: 14.3401,
    r: 1.41655,
    transform: "rotate(-45 14.5043 14.3401)",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.41797,
    y: 14.4153,
    width: 8.71209,
    height: 1.41655,
    rx: 0.708276,
    transform: "rotate(-45 8.41797 14.4153)",
    fill: "white"
  })));
};
export default SvgCouponDisabled;